import type from '@/helpers/rave/constants/types'

export default {
  [type.GENERATOR]: 'Generator',
  [type.MAN_GENERATOR]: 'Manifesting Generator',
  [type.MANIFESTOR]: 'Manifestor',
  [type.PROJECTOR]: 'Projector',
  [type.REFLECTOR]: 'Reflector'
}
